import type { AreaFormRow, FacilityCategory, FacilityFormRow, InsuranceFormData, UnitFormRow } from "./types";

export const defaultFormValues: InsuranceFormData = {
  insured: "",
  contactFullName: "",
  contactFirstName: "",
  contactAddress1: "",
  contactAddress2: "",
  contactPhone: "",
  contactEmail: "",
  address: "",
  latitude: null,
  longitude: null,
  buildingName: "",
  numberOfUnits: 1,
  propertyTypeId: "",
  useOcc: "",
  yearBuilt: null,
  eyrBuilt: null,
  land: "",
  subsoilId: "",
  upgradeRequirements: "",
  heritageListing: "",
  seismicGrade: "",
  pocFrom: "",
  pocTo: "",
  valuerPersonId: "",
  feeAmountExGst: null,
  accountNumberForXero: "",
  certificateDate: "",
  updateMonth: "",
  propertyCategory: "",
  assetDescription: "",
  construction: "",
  recreationalFeatures: "",
  retainingWalls: "",
  specialFeatures: "",
  features: "",
  detailedDescription: "",
  sModal: null,
  eModal: null,
  percentChange: null,
  percentChangeOverride: false,
  age: null,
  ageOverride: false,
  feesPercentage: null,
  demolitionPercentage: null,
  gst: 15,
  firstYearMonths: 12,
  inflationDemoPlanMonths: null,
  inflationConstructionMonths: null,
  inflationYear1: null,
  inflationYear2: null,
  inflationYear3: null,
  inflationYear4: null,
  damageAmount: null,
  damageChangePercentage: null,
  damageFirstYearMonths: null,
  damageDemoPlanMonths: null,
  damageConstructionMonths: null,
  damageInflationYear1Pct: null,
  damageInflationYear2Pct: null,
  damageInflationYear3Pct: null,
  damageInflationYear4Pct: null,
  fslText: "",
  note: "",
  excludeFromMailout: false,
  isActive: true,
  cancelled: false,
  cancelledDate: "",
  finalSentConfirmed: false,
  owner: "",
  ownerAddress: "",
  broker: "",
  brokerAddress: "",
  instructingParty: "",
  instructingEmail: "",
  invoiceTo: "",
};

export function createEmptyArea(): AreaFormRow {
  return {
    tempId: crypto.randomUUID(),
    description: "",
    eyrBuilt: null,
    eyrFollowsFirst: true,
    area: null,
    multiple: null,
    rate: null,
    rateOverride: false,
    addGst: false,
    firstYearMonths: null,
    demoPlanMonths: null,
    constructionMonths: null,
    inflationYear1Pct: null,
    inflationYear2Pct: null,
    inflationYear3Pct: null,
    inflationYear4Pct: null,
    demolitionPercentage: null,
    percentagePa: null,
    calcRate: null,
    calcReinstatementExcl: null,
    calcReinstatementIncl: null,
    calcReinstatementMonths: null,
    calcInflationAmtYear1: null,
    calcInflationAmtYear2: null,
    calcInflationAmtYear3: null,
    calcInflationAmtYear4: null,
    calcInflationTotal: null,
    calcDemolitionCost: null,
    calcDemolitionRate: null,
    calcDepreciation: null,
    calcDepreciationTotalPct: null,
    calcDrcForFsl: null,
  };
}

export function createEmptyUnit(unitNumber: number): UnitFormRow {
  return {
    tempId: crypto.randomUUID(),
    label: `Unit ${unitNumber}`,
    use: "Residential",
    configuration: "",
    grossFloorArea: null,
    includedInEstimate: true,
  };
}

export function createEmptyFacility(category: FacilityCategory = "RECREATIONAL"): FacilityFormRow {
  return {
    tempId: crypto.randomUUID(),
    category,
    description: "",
    area: null,
    multiple: null,
    rate: null,
    rateOverride: false,
    addGst: false,
    firstYearMonths: null,
    demoPlanMonths: null,
    constructionMonths: null,
    inflationYear1Pct: null,
    inflationYear2Pct: null,
    inflationYear3Pct: null,
    inflationYear4Pct: null,
    demolitionPercentage: null,
    calcRate: null,
    calcReinstatementExcl: null,
    calcReinstatementIncl: null,
    calcReinstatementMonths: null,
    calcInflationAmtYear1: null,
    calcInflationAmtYear2: null,
    calcInflationAmtYear3: null,
    calcInflationAmtYear4: null,
    calcInflationTotal: null,
    calcDemolitionCost: null,
    calcDemolitionRate: null,
  };
}
